"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
const IconUserManagement = () => /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.1",
  width: "100%",
  viewBox: "0 0 93 94"
}, /*#__PURE__*/_react.default.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
  transform: "translate(-1067 -316) translate(1067 316)"
}, /*#__PURE__*/_react.default.createElement("rect", {
  width: "93",
  height: "94",
  fill: "#ECECEC",
  rx: "23"
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: "#C4C4C4",
  d: "M76.204 34.358c-.935-2.166-3.515-3.812-5.741-3.655-2.226.157-4.8-.715-5.938-1.8-1.139-1.085-2.064-3.654-1.98-5.893.082-2.238-1.638-4.746-3.84-5.623-2.203-.877-5.177-.211-6.64 1.465-1.463 1.674-3.916 2.904-5.477 2.951-1.56.047-4.042-1.123-5.556-2.754-1.511-1.632-4.515-2.215-6.68-1.278-2.165.936-3.822 3.516-3.665 5.743.157 2.227-.715 4.8-1.8 5.94-1.085 1.14-3.653 2.053-5.879 1.98-2.226-.072-4.745 1.644-5.621 3.847-.876 2.201-.211 5.178 1.462 6.643 1.675 1.463 2.906 3.917 2.952 5.471.047 1.554-1.115 4.043-2.753 5.558-1.638 1.512-2.226 4.512-1.277 6.69.947 2.177 3.515 3.822 5.741 3.665 2.226-.157 4.799.715 5.938 1.8 1.138 1.086 2.064 3.643 1.98 5.882-.085 2.238 1.638 4.746 3.845 5.623 2.207.877 5.176.211 6.64-1.465 1.465-1.674 3.911-2.904 5.472-2.928 1.56-.023 4.042 1.135 5.567 2.766 1.523 1.632 4.523 2.19 6.687 1.254 2.165-.935 3.822-3.504 3.665-5.73-.157-2.228.715-4.801 1.8-5.94 1.085-1.14 3.646-2.052 5.884-1.962 2.237.089 4.745-1.639 5.621-3.847.876-2.208.223-5.178-1.465-6.655-1.684-1.477-2.914-3.9-2.957-5.478-.042-1.577 1.123-4.043 2.765-5.557 1.671-1.812 2.156-4.424 1.25-6.714zM51.609 57.725v-.002c-2.842 1.23-6.057 1.28-8.936.136-2.878-1.142-5.186-3.38-6.414-6.226-1.227-2.843-1.274-6.06-.13-8.938 1.14-2.879 3.38-5.187 6.225-6.414 2.843-1.226 6.058-1.273 8.935-.129 2.878 1.147 5.183 3.387 6.41 6.233 1.225 2.839 1.271 6.048.135 8.924-1.139 2.876-3.37 5.183-6.207 6.414l-.018.002z"
})))));
const _default = IconUserManagement;
var _default2 = exports.default = _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(IconUserManagement, "IconUserManagement", "/Users/jake.clayton/frontend/ls-common-client/src/components/AppMenu/IconUserManagement.js");
  reactHotLoader.register(_default, "default", "/Users/jake.clayton/frontend/ls-common-client/src/components/AppMenu/IconUserManagement.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();